import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const palette = require('../../theme/palette').default;

export const useAsyncSelectStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.5)
  },
  dropdownContainer: {
    marginTop: theme.spacing(0.5),
    height: theme.spacing(4),
    background: palette.backgrounds.dark,
    width: '100%',
    color: palette.white,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1)
  },
  dropdownIcon: {
    color: palette.white
  },
  dropdownText: {
    color: palette.adminHome.primaryBlack,
    fontWeight: 'bold'
  },
  dropdownPlaceholder: {
    opacity: 0.5
  },
  menuLoading: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(1)
  },
  menuError: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(1)
  },
  retryButton: {
    // Override pointer-events cascaded from the disabled MenuItem ancestor
    pointerEvents: 'auto'
  },
  selectRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(0.5)
  },
  removeButton: {
    color: palette.cards.red,
    padding: theme.spacing(0.5),
    flexShrink: 0
  },
  addRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5)
  },
  addHint: {
    color: palette.white,
    opacity: 0.7,
    fontSize: theme.spacing(1.5)
  },
  addButton: {
    color: palette.buttons.purple,
    fontWeight: 'bold' as const,
    textTransform: 'none' as const,
    padding: 0,
    minWidth: 'unset',
    fontSize: theme.spacing(1.5)
  }
}));

export default useAsyncSelectStyles;
